<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1>{{ $t('Eventos') }}</h1>
          </v-card-title>
          <v-card-text>
            <calendar-event-list
              :key="listKey"
              :initial-filters="initialFilters"
              @newCalendarEventClicked="showCalendarEventForm = true"
              @editEntity="editEntity"
              admin-actions
              v-if="configReady"
              entity="calendar-event"
              :reload="reload"
              @entitiesloaded="entitiesLoaded()"
              :level="1"
              search-input
              :search-config="config.adminSearch"
              default-icon="mdi-event"
            ></calendar-event-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showCalendarEventForm" max-width="600px">
      <admin-calendar-event-form
        :key="editEvent && editEvent.id ? editEvent.id : 'new-admin-calendar-event-form'"
        v-if="configReady"
        :edit-event="editEvent"
        :form-config="config.adminForm"
        @submit="submitEvent"
        @closeDialog="showCalendarEventForm = false"
      ></admin-calendar-event-form>

      <!-- <date-menu-form  @created="addDate" @closeForm="dateForm = false" ></date-menu-form> -->
    </v-dialog>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import CalendarEventList from './CalendarEventList.vue';
import AdminCalendarEventForm from './AdminCalendarEventForm.vue';

export default {
  components: {
    CalendarEventList,
    AdminCalendarEventForm,
  },
  data() {
    return {
      configReady: false,
      config: {},
      reload: false,
      showCalendarEventForm: false,
      listKey: 0,
      editEvent: {},
      initialFilters: true,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getMonthDate(month) {
      return this.year + '-' + month;
    },
    getConfig() {
      this.configReady = false;
      apiCtrl.get('/config/calendar-event').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('adminSearch')) {
          // this.searchConfig = res.data.data.adminSearch;
          this.config = res.data.data;
        }
        this.configReady = true;
      });
    },
    editEntity(data) {
      this.editEvent = data;
      this.editEvent['sync[categories]'] = this.getEntityCategoryIds(data);
      this.showCalendarEventForm = true;
    },
    getEntityCategoryIds(entity) {
      let result = null;
      if (entity.hasOwnProperty('categories')) {
        if (entity.categories[0] && entity.categories[0].hasOwnProperty('id')) {
          result = entity.categories[0].id;
          // entity.categories.forEach(category => {
          //     result.push(category.id);
          // });
        }
      }

      return result;
    },
    entitiesLoaded() {
      console.log('entitiesloaded');
      this.reload = false;
    },
    submitEvent(data) {
      let url = '/calendar-event/';
      let config = {};
      let formData = new FormData();

      /*
                    Add the form data we need to submit
                */
      for (const field in data) {
        if (data.hasOwnProperty(field)) {
          const value = data[field];
          if (value) {
            formData.append(field, value);
          }
        }
      }

      if (data.hasOwnProperty('id') && data.id) {
        url = url + data.id;
        formData.append('_method', 'put');
      }
      apiCtrl.post(url, formData, config).then(res => {
        console.log(res);
        this.showCalendarEventForm = false;
        this.initialFilters = false;
        this.listKey++;
      });
    },
  },
};
</script>
